// Upload one file through a one-shot signed URL that a sign* handler returned.
//
// The handler composes the storage path from ids it trusts, and the database
// checks the object later against storage.objects (type, size, that it exists),
// so this helper only moves bytes. It refuses early what the database would
// refuse anyway, so the operator hears it before waiting on an upload.
import { supabase } from '../lib/supabase'

export type Signed = { path: string; token: string; bucket: string }

export const DOCUMENT_ACCEPT = 'image/*,application/pdf'
const TEN_MB = 10 * 1024 * 1024

export function checkDocument(file: File, opts: { pdfJpgPngOnly?: boolean } = {}): string | null {
  const t = (file.type || '').toLowerCase()
  if (opts.pdfJpgPngOnly) {
    if (!['application/pdf', 'image/jpeg', 'image/png'].includes(t)) {
      return 'Choose a PDF, a JPG or a PNG. A screenshot saved as PNG works.'
    }
  } else if (!(t.startsWith('image/') || t === 'application/pdf')) {
    return 'Choose a photo, a screenshot or a PDF.'
  }
  if (file.size > TEN_MB) return 'That file is over 10 MB. Take the screenshot again, or save the PDF smaller.'
  return null
}

export async function uploadSigned(signed: Signed | null | undefined, file: File): Promise<string> {
  if (!signed?.path || !signed.token || !signed.bucket) throw new Error('No upload link came back for that file. Try again.')
  const { error } = await supabase.storage.from(signed.bucket).uploadToSignedUrl(signed.path, signed.token, file, {
    contentType: file.type || 'application/octet-stream',
  })
  if (error) throw new Error(`Storage refused the file: ${error.message}`)
  return signed.path
}
